export function isProxyInstance(target: unknown): boolean {
  return !!(target && (target as { __isProxy: boolean }).__isProxy);
}
